import { useState } from "react";
import { requestExternalNavigation } from "../../../../utils/externalNavigation";

import {
  SchemeModalCard,
  SchemeModalClose,
  SchemeModalBody,
  SchemeModalTitle,
  SchemeIntro,
  SchemeModalGrid,
  SchemeContent,
  SchemeSectionTitle,
  SchemeList,
  DocumentsList,
  ApplyButton,
  VideoPreview,
  VideoThumbWrap,
  VideoFrameImage,
  ComingSoonBackdrop,
  ComingSoonBanner,
} from "./SchemesBanner.styles";

import closeIcon from "../../../../assets/pages/landing/close.svg";
import popupModuleFrame from "../../../../assets/pages/landing/popup_module_frame.png";

const getVideoUrl = (url) => {
  if (!url) return "https://www.youtube.com/watch?v=IOQ-BDVGicY";
  if (url.includes("youtube.com/embed/")) return `https://www.youtube.com/watch?v=${url.split("/embed/")[1].split("?")[0]}`;

  let videoId = "";
  if (url.includes("youtu.be/")) {
    videoId = url.split("youtu.be/")[1]?.split("?")[0];
  } else if (url.includes("watch?v=")) {
    videoId = url.split("watch?v=")[1]?.split("&")[0];
  }

  return videoId ? `https://www.youtube.com/watch?v=${videoId}` : url;
};

const SchemePopupLayout = ({
  title,
  intro,
  eligibility,
  documents,
  applyLabel,
  applyHref = "#",
  videoUrl,
  onClose,
}) => {
  const [showComingSoon, setShowComingSoon] = useState(false);

  const handleApplyClick = (event) => {
    event.preventDefault();
    setShowComingSoon(true);
  };

  return (
    <SchemeModalCard role="dialog" aria-modal="true" aria-label={title}>
      <SchemeModalClose
        type="button"
        onClick={onClose}
        aria-label="Close popup"
      >
        <img src={closeIcon} alt="" />
      </SchemeModalClose>

      <SchemeModalBody>
        <SchemeModalTitle>{title}</SchemeModalTitle>

        <SchemeIntro>{intro}</SchemeIntro>

        <SchemeModalGrid>
          <SchemeContent>
            <SchemeSectionTitle>
              Eligibility Criteria
            </SchemeSectionTitle>

            <SchemeList>
              {eligibility.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </SchemeList>

            <SchemeSectionTitle>
              Documents Required
            </SchemeSectionTitle>

            <DocumentsList>
              {documents.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </DocumentsList>

            <ApplyButton href={applyHref} onClick={handleApplyClick}>
              {applyLabel}
              <span aria-hidden="true">-&gt;</span>
            </ApplyButton>
          </SchemeContent>

          <VideoPreview>
            <VideoThumbWrap>
              <a href={getVideoUrl(videoUrl)} target="_blank" rel="noopener noreferrer"
                onClick={(event) => {
                  event.preventDefault();
                  requestExternalNavigation(getVideoUrl(videoUrl));
                }}
                aria-label={`Watch ${title} video on YouTube in a new tab`}>
                <img src={`https://img.youtube.com/vi/${new URL(getVideoUrl(videoUrl)).searchParams.get("v")}/hqdefault.jpg`}
                  alt={`${title} video — open on YouTube`} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
              </a>
              <VideoFrameImage src={popupModuleFrame} alt="" />
            </VideoThumbWrap>
          </VideoPreview>
        </SchemeModalGrid>
      </SchemeModalBody>

      {showComingSoon && (
        <ComingSoonBackdrop
          role="button"
          tabIndex={0}
          aria-label="Dismiss coming soon message"
          onClick={() => setShowComingSoon(false)}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              setShowComingSoon(false);
            }
          }}
        >
          <ComingSoonBanner role="status" aria-live="polite">
            <strong>Coming Soon</strong>
            <span>Online applications for this scheme will be available shortly.</span>
          </ComingSoonBanner>
        </ComingSoonBackdrop>
      )}
    </SchemeModalCard>
  );
};

export default SchemePopupLayout;
